// ============================================================
// RS VIAJES CRM — Servicios (conexión con la API)
// ============================================================

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

// ─── TOKEN ────────────────────────────────────────────────────────────────────
const token = {
  get:    ()  => localStorage.getItem("crm_token"),
  set:    (t) => localStorage.setItem("crm_token", t),
  remove: ()  => localStorage.removeItem("crm_token"),
};

// ─── FETCH BASE ───────────────────────────────────────────────────────────────
async function api(method, path, body = null) {
  const headers = { "Content-Type": "application/json" };
  const t = token.get();
  if (t) headers["Authorization"] = `Bearer ${t}`;
  const config = { method, headers };
  if (body) config.body = JSON.stringify(body);
  const res = await fetch(`${API_URL}${path}`, config);
  if (res.status === 401) { token.remove(); window.location.href = "/"; return; }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Error del servidor");
  return data;
}

const get  = (path)       => api("GET",    path);
const post = (path, body) => api("POST",   path, body);
const patch = (path, body) => api("PATCH",  path, body);
const put  = (path, body) => api("PUT",    path, body);
const del  = (path)       => api("DELETE", path);

// ─── AUTH ─────────────────────────────────────────────────────────────────────
export const auth = {
  login:     async (email, password) => { const d = await post("/auth/login", { email, password }); token.set(d.token); return d.user; },
  logout:    async () => { await post("/auth/logout"); token.remove(); },
  me:        () => get("/auth/me"),
  isLoggedIn: () => !!token.get(),
};

// ─── CLIENTES ─────────────────────────────────────────────────────────────────
export const clientes = {
  listar:       (filtros = {}) => { const p = new URLSearchParams(filtros).toString(); return get(`/clientes${p ? `?${p}` : ""}`); },
  obtener:      (id)           => get(`/clientes/${id}`),
  crear:        (datos)        => post("/clientes", datos),
  actualizar:   (id, datos)    => patch(`/clientes/${id}`, datos),
  eliminar:     (id)           => del(`/clientes/${id}`),
  moverColumna: (id, columna_id) => patch(`/clientes/${id}/columna`, { columna_id }),
};

// ─── MENSAJES ─────────────────────────────────────────────────────────────────
export const mensajes = {
  listar:  (cliente_id, pagina = 1) => get(`/clientes/${cliente_id}/mensajes?pagina=${pagina}`),
  enviar:  (cliente_id, texto)      => post(`/clientes/${cliente_id}/mensajes`, { texto, direccion: "saliente", origen: "agente" }),
  entrante: (cliente_id, texto)     => post(`/clientes/${cliente_id}/mensajes`, { texto, direccion: "entrante", origen: "cliente" }),
};

// ─── COLUMNAS ─────────────────────────────────────────────────────────────────
export const columnas = {
  listar:      (agencia_id) => get(`/columnas${agencia_id ? `?agencia_id=${agencia_id}` : ""}`),
  crear:       (datos)      => post("/columnas", datos),
  actualizar:  (id, datos)  => patch(`/columnas/${id}`, datos),
  eliminar:    (id)         => del(`/columnas/${id}`),
  visibilidad: (id, visible_todos) => patch(`/columnas/${id}/visibilidad`, { visible_todos }),
};

// ─── USUARIOS ─────────────────────────────────────────────────────────────────
export const usuarios = {
  listar:        ()          => get("/usuarios"),
  crear:         (datos)     => post("/usuarios", datos),
  actualizar:    (id, datos) => patch(`/usuarios/${id}`, datos),
  eliminar:      (id)        => del(`/usuarios/${id}`),
  getColumnas:   (id)        => get(`/usuarios/${id}/columnas`),
  setColumnas:   (id, cols)  => put(`/usuarios/${id}/columnas`, { columnas: cols }),
};

// ─── CAMPOS ───────────────────────────────────────────────────────────────────
export const campos = {
  listar:  ()      => get("/campos"),
  crear:   (datos) => post("/campos", datos),
  eliminar: (id)   => del(`/campos/${id}`),
};

// ─── AGENCIAS ─────────────────────────────────────────────────────────────────
export const agencias = {
  listar: () => get("/agencias"),
};

// ─── FUENTES ──────────────────────────────────────────────────────────────────
export const fuentes = {
  listar:     (agencia_id) => get(`/fuentes${agencia_id ? `?agencia_id=${agencia_id}` : ""}`),
  crear:      (datos)      => post("/fuentes", datos),
  actualizar: (id, datos)  => patch(`/fuentes/${id}`, datos),
};

// ─── SEGUIMIENTOS ─────────────────────────────────────────────────────────────
export const seguimientos = {
  hoy:       ()            => get("/seguimientos"),
  crear:     (datos)       => post("/seguimientos", datos),
  actualizar: (id, estado) => patch(`/seguimientos/${id}`, { estado }),
};

// ─── ESTADÍSTICAS ─────────────────────────────────────────────────────────────
export const stats = {
  resumen:   ()            => get("/stats/resumen"),
  destinos:  ()            => get("/stats/destinos"),
  agentes:   ()            => get("/stats/agentes"),
  inactivos: (agencia_id)  => get(`/stats/inactivos${agencia_id ? `?agencia_id=${agencia_id}` : ""}`),
};

// ─── EXPORT AGRUPADO ──────────────────────────────────────────────────────────
const services = { auth, clientes, mensajes, columnas, usuarios, campos, agencias, fuentes, seguimientos, stats };
export default services;
